import { render, staticRenderFns } from "./NewProjectEnvironment.vue?vue&type=template&id=5187e8fd&scoped=true"
import script from "./NewProjectEnvironment.vue?vue&type=script&lang=js"
export * from "./NewProjectEnvironment.vue?vue&type=script&lang=js"
import style0 from "./NewProjectEnvironment.vue?vue&type=style&index=0&id=5187e8fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187e8fd",
  null
  
)

export default component.exports